/**
 * Rounds given moment up/down to full minutes.
 * Attention: Mutates the passed moment instance!
 *
 * @function
 * @param {Moment} moment - The moment time instance
 * @return {Moment} The rounded moment time object
 */
export function roundMomentToMinutes(moment) {
    if (moment.seconds() < 30) {
        moment.startOf('minute')
    } else {
        moment.add(1, 'minute').startOf('minute').toISOString()
    }
    return moment
}
